import { memo } from 'react';
import { Icon } from '@ui/components';

interface IGroupInfoErrorStateProps {
  onRetry: () => void;
}

export const GroupInfoErrorState = memo(({ onRetry }: IGroupInfoErrorStateProps) => (
  <div className="flex-1 flex flex-col justify-center items-center py-16 px-6 bg-gradient-to-b from-white via-red-50/20 to-white">
    <div className="relative mb-4">
      <div className="absolute inset-0 bg-red-500 rounded-full blur-2xl opacity-20 animate-pulse" />
      <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-red-100 to-red-200 flex items-center justify-center shadow-lg ring-4 ring-white">
        <Icon type="info" className="text-red-600 w-10 h-10" />
      </div>
    </div>
    <div className="text-lg font-bold text-gray-900 mb-2">Failed to load members</div>
    <div className="text-sm text-gray-600 mb-8 text-center max-w-sm">
      Something went wrong while fetching the members. Please try again.
    </div>
    <button
      onClick={onRetry}
      className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-orange-500 to-pink-500 text-white text-sm font-semibold shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 hover:scale-105 transition-all duration-200">
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
      Try Again
    </button>
  </div>
));

GroupInfoErrorState.displayName = 'GroupInfoErrorState';
